<template>
  <div class="breadcrumb">
    <el-row>
      <el-button
        v-if="showBackButton"
        :icon="IconChevronLeft"
        circle
        plain
        size="default"
        class="back_button"
        @click="back"
      ></el-button>
      <el-breadcrumb :separator-icon="IconChevronRight">
        <el-breadcrumb-item
          v-for="(item, index) in props.items"
          :key="index"
          :to="{ path: item.to }"
          >{{ item.label }}</el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import IconChevronLeft from '~icons/mdi/chevron-left';
import IconChevronRight from '~icons/mdi/chevron-right';

const router = useRouter();

const props = defineProps({
  items: Array,
  showBackButton: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const back = () => router.back();
</script>

<style scoped>
.breadcrumb {
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid rgb(241, 241, 241);
  padding: 0 20px;
  background-color: white;
}

.el-breadcrumb {
  font-size: 15px;
  display: flex;
  align-items: center;
}
.back_button {
  margin-right: 20px;
}
</style>
